"use client";

import { cn } from "@/lib/utils";
import Link from "next/link";
import * as React from "react";

type AuthLinkHref =
  | string
  | {
      pathname: string;
      query?: Record<string, string | number | boolean | undefined>;
    };

export interface AuthLinkProps {
  href: AuthLinkHref;
  children: React.ReactNode;
  size?: "xs" | "sm";
  tone?: "default" | "muted";
}

export function AuthLink({
  href,
  children,
  size = "xs",
  tone = "default"
}: AuthLinkProps) {
  return (
    <Link
      href={href}
      className={cn(
        "inline-flex items-center font-semibold transition-all duration-200 hover:underline hover:underline-offset-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-background",
        size === "xs" ? "text-[11px] leading-4" : "text-xs leading-4",
        tone === "default" &&
          "text-primary/95 hover:text-indigo-500 focus-visible:ring-primary/40",
        tone === "muted" &&
          "text-slate-500/75 hover:text-slate-400 hover:no-underline focus-visible:ring-slate-400/40 dark:text-zinc-500 dark:hover:text-zinc-300"
      )}
    >
      {children}
    </Link>
  );
}
